import React, { Component } from 'react';
import './Overview.css'
import moment from 'moment'
import axios from 'axios'
import { env, APIURL } from '../../../config'
import { TextField, Card, CardActions, CardContent, Icon, IconButton, Dialog, DialogTitle, DialogActions, DialogContent, Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Button, CircularProgress, Chip, Menu, MenuItem, InputAdornment, Avatar, Stack, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import SendIcon from '@mui/icons-material/Send';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import VideocamIcon from '@mui/icons-material/Videocam';
import EditIcon from '@mui/icons-material/Edit';
import EventIcon from '@mui/icons-material/Event';
import PhoneIcon from '@mui/icons-material/Phone';
import NavigationIcon from '@mui/icons-material/Navigation';
import CreateReferral from '../../Referral/CreateReferral';
import NoteFormv2 from '../../../components/forms/NoteForm/NoteFormv2';
import TaskForm from '../../../components/forms/TaskForm/TaskForm';
import MessagePage from '../../../components/MessagePages/MessagePage'
import CustomerForm from '../../../components/forms/CustomerForm/CustomerForm';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles'
import MUIRichTextEditor from 'mui-rte';
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'material-react-toastify';
import JitsiCallDialog from '../../../components/VideoCall/JitsiCallDialog';
import Collapse from '@mui/material/Collapse';
var Buffer = require('buffer/').Buffer;
// import dd from '../../../manifestdd.json'



const myTheme = createTheme({
    overrides: {
        MUIRichTextEditor: {
            anchorLink: {
                color: "lightblue",
                textDecoration: "underline",
            },
        },
    },
});

class Overview extends Component {
    state = {
        contextMenu: 0,
        showMore: false,
        displayNotes: [],
        editNote: null,
        editCust: null,
        content: [],
        loading: true,
        currentCustomer: null,
        completedTaskData: [],
        customerType: null,
        customerStatus: null,
        loc_list: null,
        empList: null,
        pManagerId: null,
        pId: null,
        editLoading: true,
        customers: { list: [{}], customerType: [], customerStatus: [] },
        locations: { list: [{}], states: [], locType: [], locStatus: [] },
        mapRender: "cust",
        newCustLoading: true,
        taskTypes: [],
        customer_tasks: [],
        image: null,
        schema: null,
        schemaDefaults: null,
        AH_Dialog: false,
        customerEmail: this.props.cust_details.cus_email,
        isCustomerAssociated: false,
        sendingInvite: false,
        isAH_InviteSent: false,
        ahRelationship: null,
        videoCall: { open: false, roomName: null, subject: null, starting: false },
        referralDialogOpen: false,
        preferredEmployees: [],
        customerGoals: [],
        nextVisit: null,
        lastCallLog: null,
        quickNoteText: '',
        quickNoteDialogOpen: false,
        quickActionAnchor: null,
        savingQuickNote: false,
        scheduleTaskDialogOpen: false,
        scheduleTaskFormData: null,
        displayItems: [],
        expandedItems: {},
    }

    async fetchData() {
        this.setState({ loading: true, displayItems: [] });
        console.log(this.props);
        
        let custTasks = await axios.get(APIURL + "/customers/CustomerTasks", { params: { comp_id: this.props.comp_id, customer_id: this.props.cust_details.cus_id } });

        if (custTasks.data.length !== 0) {
            let types = []
            custTasks.data.forEach((task) => {
                types.push(task.EntityValue)
            })
            this.setState({ taskTypes: types })
        }
        else {
            let taskTypeList = await axios.get(APIURL + "/dropdowns/dropdownType/taskType", {
                params: { comp_id: this.props.comp_id },
            });
            this.setState({ taskTypes: taskTypeList.data })
        }

        const response = await axios.get(APIURL + `/comments`, {
            params: { customer_id: this.props.cus_id, empID: this.props.user?.emp_id }
        })
        let notes = response.data
        notes = await Promise.all(notes.map(async (note) => {
            const noteDataResponse = await axios.get(APIURL + `/comments/details`, {
                params: { comment_id: note.comment_id, empID: this.props.user?.emp_id }
            })
            const noteData = noteDataResponse.data[0]
            return noteData
        }))

        notes = notes.filter((note) => note !== undefined);

        const audioResp = await axios.get(APIURL + `/audio_note`, {
            params: { customer_id: this.props.cus_id },
        });

        let audioNotes = audioResp.data.map((audioNote) => ({
            ...audioNote,
            created_at: audioNote.submitted,
        }));

        notes.push(...audioNotes)

        notes.sort((a, b) => {
            return moment(a.created_at).isBefore(moment(b.created_at)) ? 1 : -1;
        })
        const fullNoteList = [...notes];
        notes = notes.slice(0, 5);

        this.setState({ displayNotes: notes, currentCustomer: this.props.cus_id })
        this.generateNoteCards(notes)

        // Last call log — most recent audio note for this customer
        const lastCallLog = audioNotes.length > 0 ? audioNotes[0] : null;
        this.setState({ lastCallLog });

        // Build a normalized note item for the activity timeline
        const buildNoteItem = (n) => {
            let audioSrc = null;
            if (n.audioNote) {
                try {
                    const decodedData = Buffer.from(n.audioNote[0].audio_note, 'base64');
                    const blob = new Blob([decodedData], { type: 'audio/wav' });
                    audioSrc = URL.createObjectURL(blob);
                } catch (_) {}
            }
            return {
                type: n.audioNote ? 'audio' : 'note',
                date: n.created_at,
                title: n.note_title || n.tas_title || n.pro_title || '',
                contextLabel: n.note_title ? (n.tas_title || n.pro_title || n.cus_name || '') : '',
                subTitle: n.tas_type || '',
                content: n.comment_text || '',
                createdBy: n.emp_first_name ? `${n.emp_first_name} ${n.emp_last_name}` : null,
                empType: n.emp_type || null,
                updatedBy: (n.updated_by && n.updated_emp_first_name) ? `${n.updated_emp_first_name} ${n.updated_emp_last_name}` : null,
                updatedAt: n.updated_at || null,
                audioSrc,
                editNote: n.audioNote ? null : n,
            };
        };

        // Next scheduled visit + activity timeline (notes + tasks from all active projects)
        try {
            let allTasks = [];
            const customerProjectsResp = await axios.get(APIURL + '/project', { params: { cus_id: this.props.cus_id } });
            const customerProjects = customerProjectsResp.data || [];
            const activeProjects = customerProjects.filter((p) => p?.pro_is_active !== false);

            if (activeProjects.length > 0) {
                const projectTaskResponses = await Promise.all(
                    activeProjects.map((p) => axios.get(APIURL + '/project/projTask', { params: { proj_id: p.pro_id } }))
                );
                allTasks = projectTaskResponses.flatMap((resp) => resp.data || []);
            } else {
                const tasksResp = await axios.get(APIURL + '/task', { params: { com_id: this.props.comp_id, cust_id: this.props.cus_id } });
                allTasks = tasksResp.data || [];
            }

            const uniqTaskMap = new Map();
            allTasks.forEach((task) => {
                if (!task) return;
                const key = task.tas_id || `${task.tas_title || ''}-${task.tas_start_time || task.tas_start_date || ''}`;
                if (!uniqTaskMap.has(key)) uniqTaskMap.set(key, task);
            });
            allTasks = [...uniqTaskMap.values()];

            const now = moment();
            const futureTasks = allTasks
                .filter(t => t.tas_is_active === 0 && t.tas_start_date && moment(t.tas_start_date).isSameOrAfter(now, 'day'))
                .sort((a, b) => moment(a.tas_start_date).diff(moment(b.tas_start_date)));
            this.setState({ nextVisit: futureTasks[0] || null });

            const activityTasks = allTasks.filter(t => t && t.tas_is_active !== 2);
            const taskItems = activityTasks.map(t => ({
                type: 'task',
                date: t.created_at || t.tas_created_at || (t.tas_start_time ? moment(t.tas_start_time.replace(/Z/g, '')).toISOString() : t.tas_start_date),
                title: t.tas_title || t.tas_type || 'Task',
                subTitle: t.tas_type || '',
                content: t.tas_description || '',
                createdBy: t.emp_first_name ? `${t.emp_first_name} ${t.emp_last_name}` : null,
                empType: null,
                audioSrc: null,
                editNote: null,
            }));
            const displayItems = [...fullNoteList.map(buildNoteItem), ...taskItems]
                .sort((a, b) => moment(b.date).diff(moment(a.date)))
                .slice(0, 20);
            this.setState({ displayItems, loading: false });
        } catch (e) {
            console.error('Failed to fetch tasks:', e);
            this.setState({
                nextVisit: null,
                displayItems: fullNoteList.map(buildNoteItem).sort((a, b) => moment(b.date).diff(moment(a.date))),
                loading: false,
            });
        }

        // Fetch customer goals for Goal Status Widget
        try {
            const goalsResp = await axios.get(APIURL + `/customer_goal?customer_id=${this.props.cus_id}`);
            this.setState({ customerGoals: goalsResp.data.filter(g => g.goal_status !== 3) });
        } catch (e) {
            this.setState({ customerGoals: [] });
        }

        // Fetch schema for this company and table
        try {
            const schemaRes = await axios.get(
                `${APIURL}/schema/table/customer`,
                { params: { companyID: this.props.comp_id } }
            );
            const schemaDefaultsRes = await axios.get(
                `${APIURL}/schema/table-default/customer`,
                {
                    params: {
                        companyState: this.props.user.comp_settings.find(setting => setting.feature_id === 99)?.state_id || null,
                        companyTypeOfBusiness: this.props.user.comp_settings.find(setting => setting.feature_value === 'primaryBusinessType')?.feature_id || null,
                    }
                }
            );
            this.setState({
                schema: schemaRes.data,
                schemaDefaults: schemaDefaultsRes.data
            });

            console.log('schema', schemaRes.data)
            console.log('schemaDefaults', schemaDefaultsRes.data);

        } catch (err) {
            // Optionally handle schema fetch errors
            this.setState({ schema: null, schemaDefaults: null });
        }

        if (this.state.customerEmail?.trim()) {
            await axios
                .get(APIURL + `/customers/assigned?`, {
                    params: { emp_id: this.props.user.emp_id }
                }).then(async (response) => {
                    const isCustomerAssociated = response.data.customers.find(cus => cus.cus_id === this.props.cust_details.cus_id);
                    this.setState({ isCustomerAssociated: !!isCustomerAssociated });

                    if (!!isCustomerAssociated) {
                        await axios
                            .get(APIURL + "/ability_hub/getInvites", {
                                params: { userEmail: this.props.user.sec_email }
                            }).then((response) => {
                                const invites = response.data.filter(inv => inv.patientUserEmail === this.state.customerEmail)
                                this.setState({
                                    isAH_InviteSent: !!invites.length,
                                    ahRelationship: invites.find(inv => inv.status === 2) || null
                                });
                            }).catch((error) => {
                                console.log(error);
                            });
                    }
                }).catch((error) => {
                    console.log(error);
                });
        }

        // Fetch preferred employees for this customer
        try {
            const prefEmpResponse = await axios.get(APIURL + "/customers/employeePreference", {
                params: { customer_id: this.props.cust_details.cus_id }
            });
            // Sort by preference level (highest first), then by name
            const sortedPreferences = (prefEmpResponse.data.preferences || []).sort((a, b) => {
                if (b.preference_level !== a.preference_level) {
                    return (b.preference_level || 0) - (a.preference_level || 0);
                }
                return (a.employee_name || '').localeCompare(b.employee_name || '');
            });
            this.setState({ preferredEmployees: sortedPreferences });
        } catch (error) {
            console.log('Error fetching preferred employees:', error);
            this.setState({ preferredEmployees: [] });
        }
    }

    async fetchProjData() {
        this.setState({ completedTaskData: [], taskCount: '...' })
        const response = await axios.get(APIURL + `/project`, { params: { cus_id: this.props.cus_id } })
        let projects = response.data

        projects.length !== 0 && this.setState({ pManagerId: projects[0].pro_manager_id, pId: projects[0].pro_id })

        let taskTimeSpent = []
        for (let i = 0; i < projects.length; i++) {
            let completedTaskData = await axios.get(APIURL + '/locate/TimeSpent', { params: { projId: projects[i].pro_id, comp_id: this.props.comp_id } })
            taskTimeSpent.push(...completedTaskData.data)
        }
        this.setState({ completedTaskData: taskTimeSpent, taskCount: taskTimeSpent.length })
    }

    async fetchCustomerImage() {
        const response = await axios.get(APIURL + `/customers/image`, { params: { customer_id: this.props.cust_details.cus_id } });
        const imageBase64 = response.data.image
        this.setState({ image: imageBase64 })
    }

    async fetchCusEditData() {
        let location_list = await axios.get(APIURL + '/dropdowns/dropdownType/locationslist', { params: { comp_id: this.props.comp_id } })
        let cusType = await axios.get(APIURL + '/dropdowns/dropdownType/customerType', { params: { comp_id: this.props.comp_id } })
        let cusStatus = await axios.get(APIURL + '/dropdowns/dropdownType/customerStatus', { params: { comp_id: this.props.comp_id } })
        let employee_list = await axios.get(APIURL + '/dropdowns/dropdownType/employeeslist', { params: { comp_id: this.props.comp_id } })

        this.setState({ editLoading: false, customerType: cusType.data, customerStatus: cusStatus.data, loc_list: location_list.data, empList: employee_list.data })
    }

    calCumulativeTimeSpent = () => {
        var TotalTime = moment()
        this.state.completedTaskData.forEach((taskData) => {
            var CheckInTime = moment(taskData.CheckInTime)
            var CheckoutTime = moment(taskData.CheckoutTime)
            var taskTime = moment.duration(CheckoutTime.diff(CheckInTime))
            TotalTime.add(taskTime)
        })
        return moment.duration(TotalTime.diff(moment())).humanize()
    }

    componentDidMount() {
        this.fetchData()
        this.fetchProjData()
        this.fetchCustomerImage()
    }

    async componentDidUpdate(prevProps, prevState) {
        if ((prevState.contextMenu !== this.state.contextMenu) || (prevProps.cus_id !== this.props.cus_id)) {
            this.fetchData()
            this.fetchProjData()
        }

        if (this.state.contextMenu === 1 && !!this.state.editLoading) {
            await this.fetchCusEditData()
        }

        if (this.props.cust_details.cus_id !== prevProps.cust_details.cus_id) {
            this.setState({ image: null, customerEmail: this.props.cust_details.cus_email })
            this.fetchCustomerImage();
        }
    }

    handleShowMoreToggle = () => {
        this.setState((prevState) => ({ showMore: !prevState.showMore }));
    };

    isJSON = (str) => {
        if (str === null || str === undefined || typeof str !== 'string') return false;
        try {
            const parsed = JSON.parse(str);
            return parsed !== null && typeof parsed === 'object';
        } catch (e) {
            return false;
        }
    }

    generateNoteCard = (note) => {
        let audioSrc;

        if (note.audio_note) {
            const decodedData = Buffer.from(note.audioNote[0].audio_note, 'base64');

            const blob = new Blob([decodedData], { type: 'audio/wav' });

            audioSrc = URL.createObjectURL(blob);
        }

        return (
            <Card sx={{ marginBottom: '20px', width: '100%', maxWidth: 'none' }}>
                <CardActions sx={{ paddingLeft: '16px', paddingRight: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 0 }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ minWidth: 0 }}>
                                    {note.note_title && <h6 style={{ marginBottom: '0px', marginRight: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{note.note_title}</h6>}
                                    {!note.note_title ?
                                        <h6 style={{ marginBottom: '0px', marginRight: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{note.tas_title ? note.tas_title : note.pro_title ? note.pro_title : note.cus_name}</h6> :
                                        <p style={{ marginBottom: '0px', color: 'gray', fontSize: 13 }}>{note.tas_title ? note.tas_title : note.pro_title ? note.pro_title : note.cus_name}</p>
                                    }
                                    <span style={{ display: 'block', color: 'gray', fontSize: 13, marginBottom: 0, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {note.tas_type}
                                    </span>
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}>
                                <div style={{ fontSize: 13, color: 'gray', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: 8 }}>
                                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {moment(note.created_at).format('MM/DD/YYYY hh:mm A')} created by {note.emp_first_name + ' ' + note.emp_last_name} ({note.emp_type})
                                    </span>
                                    {!!note.updated_by && !!note.updated_at &&
                                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {moment(note.updated_at).format('MM/DD/YYYY hh:mm A')} updated by {note.updated_emp_first_name + ' ' + note.updated_emp_last_name}
                                        </span>
                                    }
                                </div>
                                {!note.audioNote &&
                                    <IconButton
                                        style={{ marginLeft: 0 }}
                                        onClick={() => this.setState({ editNote: note })}
                                    >
                                        <Icon style={{ fontSize: '16px' }} baseClassName="fas" className="fa-edit" />
                                    </IconButton>
                                }
                            </div>
                        </div>
                    </div>
                </CardActions>
                <CardContent sx={{ paddingBottom: '0px', paddingTop: '0px' }}>
                    <hr style={{ marginBottom: '10px', marginTop: '0px', backgroundColor: '#e2ecfa' }}></hr>
                    {!note.audioNote &&
                        <ThemeProvider theme={myTheme}>
                            <MUIRichTextEditor
                                defaultValue={this.isJSON(note.comment_text) ? note.comment_text : `{"blocks":[{"key":"block1","text":"${(note.comment_text || '').replace(/\\/g, '\\\\').replace(/\n/g, ' ').replace(/\t/g, ' ').replace(/"/g, '\\"')}","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`}
                                readOnly={true}
                                toolbar={false}
                            />
                        </ThemeProvider>}
                    {note.audioNote && <audio controls src={audioSrc} />}
                </CardContent>
            </Card>
        );
    }

    generateNoteCards = (noteList) => {
        let cards = []
        cards = noteList.map((note) => {
            return this.generateNoteCard(note)
        })
        this.setState({ content: cards })
    }

    navigationHandler = (contextMenu) => {
        this.setState({ contextMenu })
    }

    validateEmail = (value) => {
        if (!value) return true;
        if (!/\S+@\S+\.\S+/.test(value)) return false;
        return true;
    }

    handleInvite = async () => {
        this.setState({ sendingInvite: true });

        if (this.state.customerEmail?.trim() !== this.props.cust_details.cus_email?.trim()) {
            await axios.put(APIURL + '/customers/email', {
                cus_id: this.props.cust_details.cus_id,
                cus_email: this.state.customerEmail
            }).then((response) => {
                console.log(response);
            }).catch((error) => {
                console.log(error);
            });
        }

        await axios.post(APIURL + "/ability_hub", {
            compName: this.props.user.company_name,
            empEmail: this.props.user.sec_email,
            empName: this.props.user.emp_name,
            cusEmail: this.state.customerEmail,
            cusName: this.props.cust_details.cus_name,
            inviteType: 'Customer',
            customer_id: this.props.cust_details.cus_id,
        }).then((response) => {
            console.log(response);
        }).catch((error) => {
            console.log(error);
        });

        this.handleCloseAH_Dialog();
        this.setState({ sendingInvite: false });
    }

    handleCloseAH_Dialog = () => {
        this.setState({ AH_Dialog: false, customerEmail: this.props.cust_details.cus_email });
    }

    startVideoCall = async () => {
        this.setState({ quickActionAnchor: null, videoCall: { ...this.state.videoCall, starting: true } });
        try {
            const response = await axios.post(APIURL + '/ability_hub/videocall/room', {
                userEmail: this.props.user.sec_email,
                custEmail: this.state.customerEmail,
            });
            this.setState({
                videoCall: {
                    open: true,
                    roomName: response.data.roomName,
                    subject: response.data.subject || this.props.cust_details.cus_name,
                    starting: false,
                }
            });
        } catch (error) {
            console.log(error);
            this.setState({ videoCall: { open: false, roomName: null, subject: null, starting: false } });
            toast.error(error.response?.data?.message || 'Could not start the video call. Please try again.');
        }
    }

    logVideoCall = async ({ startedAt, endedAt, viaBeacon }) => {
        const payload = {
            userEmail: this.props.user.sec_email,
            custEmail: this.state.customerEmail,
            cus_id: this.props.cust_details.cus_id,
            comp_id: this.props.comp_id,
            emp_id: this.props.user.emp_id,
            pro_id: this.state.pId,
            isBillable: this.props.user.comp_settings.find((setting) => setting.feature_id === 56)?.feature_value === 'true',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            startedAt,
            endedAt,
        };

        // The tab is closing: a normal request would be cancelled mid-flight. sendBeacon has
        // to use form encoding, since a JSON content-type would need a CORS preflight it
        // cannot perform.
        if (viaBeacon) {
            if (navigator.sendBeacon) {
                const body = new URLSearchParams();
                Object.entries(payload).forEach(([key, value]) => {
                    if (value !== null && value !== undefined) body.append(key, value);
                });
                navigator.sendBeacon(APIURL + '/ability_hub/videocall/log', body);
            }
            return;
        }

        try {
            await axios.post(APIURL + '/ability_hub/videocall/log', payload);
        } catch (error) {
            // The call itself succeeded -- failing to log it must not look like a broken call.
            console.log(error);
        }
    }

    openScheduleTaskDialog = async () => {
        this.setState({ quickActionAnchor: null, scheduleTaskDialogOpen: true, scheduleTaskFormData: null });
        try {
            const [empRes, projRes, taskTypeRes, locRes] = await Promise.all([
                axios.get(APIURL + '/dropdowns/dropdownType/employeeslist', { params: { comp_id: this.props.comp_id } }),
                axios.get(APIURL + '/dropdowns/dropdownType/projectslist', { params: { comp_id: this.props.comp_id } }),
                axios.get(APIURL + '/dropdowns/dropdownType/taskType', { params: { comp_id: this.props.comp_id } }),
                axios.get(APIURL + '/dropdowns/dropdownType/locationslist', { params: { comp_id: this.props.comp_id } }),
            ]);
            this.setState({
                scheduleTaskFormData: {
                    empList: empRes.data,
                    projList: projRes.data,
                    taskType: taskTypeRes.data,
                    locList: locRes.data,
                }
            });
        } catch (e) {
            console.error('Failed to load task form data:', e);
        }
    }

    handleQuickNoteSave = async () => {
        const text = this.state.quickNoteText.trim();
        if (!text || this.state.savingQuickNote) return;
        this.setState({ savingQuickNote: true });
        try {
            await axios.post(APIURL + '/comments', {
                cus_id: this.props.cus_id,
                emp_id: this.props.user.emp_id,
                note_title: '',
                comment_text: JSON.stringify({ blocks: [{ key: 'block1', text: text, type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} }], entityMap: {} }),
            });
            this.setState({ quickNoteText: '' });
            this.fetchData();
        } catch (err) {
            console.error('Quick note save failed:', err);
        } finally {
            this.setState({ savingQuickNote: false });
        }
    }

    render() {
        let phoneNumbers = []
        let addresses = []
        try {
            phoneNumbers = this.props.cust_details.cus_phone.split(',')
            addresses = this.props.cust_details.cus_address.split(':')
        } catch (err) {
            console.log(err)
        }
        let timeSpent = this.calCumulativeTimeSpent()


        const isFieldVisible = (field) => {
            let schemaField = this.state.schema?.find(s => s.columnName?.toLowerCase() === field.toLowerCase());
            if (schemaField && schemaField.columnVisible !== undefined && schemaField.columnVisible !== null) {
                return !!schemaField.columnVisible;
            }
            let defaultField = this.state.schemaDefaults?.find(s => s.columnName?.toLowerCase() === field.toLowerCase());
            if (defaultField && defaultField.columnVisible !== undefined && defaultField.columnVisible !== null) {
                return !!defaultField.columnVisible;
            }
            return true;
        };

        // Helper to get the display label for a field
        const getFieldLabel = (field, fallback) => {
            let schemaField = this.state.schema?.find(s => s.columnName?.toLowerCase() === field.toLowerCase());
            if (schemaField && schemaField.columnLabel) {
                return schemaField.columnLabel;
            }
            let defaultField = this.state.schemaDefaults?.find(s => s.columnName?.toLowerCase() === field.toLowerCase());
            if (defaultField && defaultField.columnLabel) {
                return defaultField.columnLabel;
            }
            return fallback;
        };

        let content = null;
        if (this.state.contextMenu === 1) {
            content =
                <Dialog fullWidth={true} maxWidth={'sm'} open={this.state.contextMenu === 1} onClose={() => this.navigationHandler(0)}>
                    <DialogActions>
                        <h4 style={{ marginLeft: '20px', marginTop: '10px' }}>Edit Customer Details</h4>
                        <hr style={{ marginBottom: '10px', marginTop: '10px', backgroundColor: '#e2ecfa' }}></hr>
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            sx={{ p: 0.25 }}
                            onClick={() => this.navigationHandler(0)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogActions>
                    <DialogContent sx={{ paddingTop: '0px' }}>
                        {!!this.state.editLoading &&
                            <div className='d-flex flex-row w-100 justify-content-center mt-5'>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        }
                        {!this.state.editLoading && <CustomerForm
                            history={this.props.history}
                            isFormValidated={this.props.isFormValidated}
                            customerStatus={this.state.customerStatus}
                            customerType={this.state.customerType}
                            states={this.props.states}
                            empList={this.state.empList}
                            tasklist={this.props.project_tasks}
                            loc_list={this.state.loc_list}
                            edit={true}
                            comp_id={this.props.comp_id}
                            cusDets={this.props.cust_details}
                            pId={this.state.pId}
                            pManagerId={this.state.pManagerId}
                            user={this.props.user}
                            // Pass schema data to CustomerForm
                            schema={this.state.schema}
                            schemaDefaults={this.state.schemaDefaults}
                        />}
                    </DialogContent>
                </Dialog>
        }
        else if (this.state.contextMenu === 0) {
            const statusColor = this.props.cust_details.cus_status === 'Active' ? '#2e7d32'
                : this.props.cust_details.cus_status === 'Inactive' ? '#b71c1c' : '#e65100';

            content = (
                <div className="overview-redesign">
                    {/* Persistent Dialogs */}
                    <Dialog open={this.state.referralDialogOpen} onClose={() => this.setState({ referralDialogOpen: false })} maxWidth="md" fullWidth>
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            Create Referral for {this.props.cust_details.cus_name}
                            <IconButton onClick={() => this.setState({ referralDialogOpen: false })}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <CreateReferral
                                comp_id={this.props.comp_id}
                                user={this.props.user}
                                com_name={this.props.user?.com_name}
                                preselectedCustomer={{ cus_id: this.props.cust_details.cus_id, name: this.props.cust_details.cus_name, addressString: this.props.cust_details.cus_address, email: this.props.cust_details.cus_email }}
                                onSuccess={() => this.setState({ referralDialogOpen: false })}
                            />
                        </DialogContent>
                    </Dialog>

                    <Dialog open={this.state.AH_Dialog} onClose={this.handleCloseAH_Dialog}>
                        <DialogTitle sx={{ width: '100%', textAlign: 'center', borderBottom: '1px solid lightgray' }}>
                            Invite <span style={{ color: '#1976D2' }}>{this.props.cust_details.cus_name}</span> to Ability Hub
                        </DialogTitle>
                        <DialogContent>
                            <TextField label="Invite From" value={this.props.user.sec_email} sx={{ marginTop: 2, marginBottom: 2 }} size="small" fullWidth disabled />
                            <TextField label="Invite To" value={this.state.customerEmail} onChange={(e) => this.setState({ customerEmail: e.target.value })} size="small" fullWidth error={!this.validateEmail(this.state.customerEmail)} />
                            {!this.validateEmail(this.state.customerEmail) && <Typography color="error">Please enter a valid email</Typography>}
                            <Button fullWidth variant="contained" color="primary" sx={{ marginTop: 2 }} onClick={this.handleInvite}
                                disabled={this.state.sendingInvite || !this.state.customerEmail || !this.validateEmail(this.state.customerEmail) || env === 'test'}>
                                {this.state.sendingInvite ? <CircularProgress size={24} color="inherit" /> : 'Invite'}
                            </Button>
                        </DialogContent>
                    </Dialog>

                    <Dialog fullWidth maxWidth="lg" open={this.state.quickNoteDialogOpen} onClose={() => this.setState({ quickNoteDialogOpen: false })}>
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            New Visit Note
                            <IconButton onClick={() => this.setState({ quickNoteDialogOpen: false })}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent sx={{ paddingTop: '8px' }}>
                            <NoteFormv2 mode="add" checkTokenExpiry={this.props.checkTokenExpiry} user={this.props.user} customer_id={this.props.cus_id} company_id={this.props.comp_id} onSubmit={() => { this.setState({ quickNoteDialogOpen: false }); this.fetchData(); }} />
                        </DialogContent>
                    </Dialog>

                    <JitsiCallDialog
                        open={this.state.videoCall.open}
                        roomName={this.state.videoCall.roomName}
                        subject={this.state.videoCall.subject}
                        user={this.props.user}
                        onCallEnded={this.logVideoCall}
                        onClose={() => this.setState({ videoCall: { open: false, roomName: null, subject: null, starting: false } })}
                    />

                    <Dialog fullWidth maxWidth="sm" open={this.state.scheduleTaskDialogOpen} onClose={() => this.setState({ scheduleTaskDialogOpen: false, scheduleTaskFormData: null })}>
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            Schedule New Task
                            <IconButton onClick={() => this.setState({ scheduleTaskDialogOpen: false, scheduleTaskFormData: null })}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent sx={{ paddingTop: '8px' }}>
                            {!this.state.scheduleTaskFormData && (
                                <div className='d-flex flex-row w-100 justify-content-center mt-5'>
                                    <CircularProgress />
                                </div>
                            )}
                            {this.state.scheduleTaskFormData && (
                                <TaskForm
                                    {...this.props}
                                    isFormValidated={this.props.isFormValidated}
                                    empList={this.state.scheduleTaskFormData.empList}
                                    locList={this.state.scheduleTaskFormData.locList}
                                    projList={this.state.scheduleTaskFormData.projList}
                                    taskType={this.state.scheduleTaskFormData.taskType}
                                    comp_id={this.props.comp_id}
                                    customerPage={true}
                                    cus_id={this.props.cus_id}
                                    goHome={() => { this.setState({ scheduleTaskDialogOpen: false, scheduleTaskFormData: null }); this.fetchData(); }}
                                />
                            )}
                        </DialogContent>
                    </Dialog>

                    <Dialog fullWidth maxWidth="lg" open={this.state.editNote != null}>
                        <DialogActions>
                            <IconButton aria-label="close" color="inherit" sx={{ p: 0.25 }} onClick={() => this.setState({ editNote: null })}><CloseIcon /></IconButton>
                        </DialogActions>
                        <DialogContent sx={{ paddingTop: '0px' }}>
                            <NoteFormv2 mode='edit' checkTokenExpiry={this.props.checkTokenExpiry} project_id={this.state.editNote?.proj_id} task_id={this.state.editNote?.tas_id} note_id={this.state.editNote?.comment_id} user={this.props.user} customer_id={this.props.cus_id} company_id={this.props.comp_id} onSubmit={() => { this.setState({ editNote: null }); this.fetchData(); this.fetchProjData(); }} />
                        </DialogContent>
                    </Dialog>

                    <input id="fileInput" type="file" accept="image/*" style={{ display: 'none' }}
                        onChange={async (event) => {
                            let formData = new FormData();
                            formData.append("file", event.target.files[0]);
                            formData.append("customer_id", this.props.cust_details.cus_id);
                            await axios.post(APIURL + `/customers/image`, formData, {});
                            event.target.value = null;
                            this.fetchCustomerImage();
                        }}
                    />

                    {/* Grid: Snapshot Header + Body */}
                    <Grid container spacing={2} className="overview-body" sx={{ alignItems: 'stretch' }}>

                    {/* Snapshot Header */}
                    <Grid size={{ xs: 12 }}>
                    <div className="snapshot-header">
                        <div className="snapshot-identity">
                            {this.state.image && (
                                <img src={`data:image/jpeg;base64,${this.state.image}`} className="snapshot-avatar" alt="client" />
                            )}
                            <div>
                                <div className="snapshot-name">{this.props.cust_details.cus_name}</div>
                                <div className="snapshot-sub">
                                    {this.props.cust_details.cus_type && <span>{this.props.cust_details.cus_type}</span>}
                                    {this.props.cust_details.cus_type && this.props.cust_details.cus_status && <span>, </span>}
                                    {this.props.cust_details.cus_status && <span style={{ color: statusColor, fontWeight: 600 }}>{this.props.cust_details.cus_status}</span>}
                                </div>
                            </div>
                        </div>

                        <div className="snapshot-chips">
                            {this.props.cust_details.cus_status && (
                                <Chip label={this.props.cust_details.cus_status} size="small"
                                    sx={{ backgroundColor: statusColor, color: '#fff', fontWeight: 600, fontSize: '0.75rem' }} />
                            )}
                            {this.props.cust_details.DDD_tier && (
                                <Chip label={`Tier ${this.props.cust_details.DDD_tier} Support`} size="small" color="info"
                                    sx={{ fontSize: '0.72rem', height: '22px' }} />
                            )}
                        </div>

                        <div className="snapshot-stat">
                            <span className="snapshot-stat-label">Next Scheduled Visit</span>
                            <span className="snapshot-stat-value">
                                {this.state.nextVisit ? (
                                    <>
                                        {moment(this.state.nextVisit.tas_start_date).format('ddd, MMM D')}
                                        {this.state.nextVisit.tas_start_time ? `, ${moment(this.state.nextVisit.tas_start_time, 'HH:mm:ss').format('h:mm A')}` : ''}
                                        {this.state.nextVisit.tas_type ? ` - ${this.state.nextVisit.tas_type}` : ''}
                                        <Icon baseClassName="fas" className="fa-calendar" style={{ fontSize: 13, color: '#555' }} />
                                    </>
                                ) : (
                                    <span style={{ color: '#aaa' }}>No upcoming visits</span>
                                )}
                            </span>
                        </div>

                        <div className="snapshot-stat">
                            <span className="snapshot-stat-label">Last Call Log</span>
                            <span className="snapshot-stat-value">
                                {this.state.lastCallLog ? (
                                    <>
                                        {moment(this.state.lastCallLog.submitted).fromNow()}
                                        <Icon baseClassName="fas" className="fa-phone" style={{ fontSize: 13, color: '#555' }} />
                                    </>
                                ) : (
                                    <span style={{ color: '#aaa' }}>No recent calls</span>
                                )}
                            </span>
                        </div>

                        <div className="snapshot-actions">
                            <Tooltip title="Edit Customer">
                                <IconButton size="small" onClick={() => this.navigationHandler(1)}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Upload Customer Image">
                                <IconButton size="small" onClick={() => document.getElementById("fileInput").click()}>
                                    <Icon style={{ fontSize: '16px' }} baseClassName="fas" className="fa-image" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Download Customer Badge PDF">
                                <IconButton size="small" onClick={async () => {
                                    const response = await axios.get(APIURL + `/customers/detailsPDF`, { params: { customer_id: this.props.cust_details.cus_id }, responseType: 'blob' });
                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', 'customer.pdf');
                                    document.body.appendChild(link);
                                    link.click();
                                }}>
                                    <Icon style={{ fontSize: '16px' }} baseClassName="fas" className="fa-qrcode" />
                                </IconButton>
                            </Tooltip>
                            <Button
                                variant="contained"
                                color="primary"
                                endIcon={<ArrowDropDownIcon />}
                                onClick={(e) => this.setState({ quickActionAnchor: e.currentTarget })}
                                sx={{ fontWeight: 700, fontSize: '0.82rem', whiteSpace: 'nowrap', ml: 1, px: 2, py: 0.8 }}
                            >
                                QUICK ACTION
                            </Button>
                            <Menu
                                anchorEl={this.state.quickActionAnchor}
                                open={Boolean(this.state.quickActionAnchor)}
                                onClose={() => this.setState({ quickActionAnchor: null })}
                            >
                                <MenuItem onClick={() => { this.setState({ quickNoteDialogOpen: true, quickActionAnchor: null }); }}>
                                    <NoteAddIcon sx={{ mr: 1, fontSize: 18 }} /> New Visit Note
                                </MenuItem>
                                <MenuItem onClick={this.openScheduleTaskDialog}>
                                    <EventIcon sx={{ mr: 1, fontSize: 18 }} /> Schedule New Task
                                </MenuItem>
                                {this.props.user.subs.find((s) => s.feature_id === 22) && this.state.isCustomerAssociated && (
                                    <MenuItem onClick={() => { this.setState({ AH_Dialog: true, quickActionAnchor: null }); }} disabled={this.state.isAH_InviteSent}>
                                        {this.state.isAH_InviteSent ? <MarkEmailReadIcon sx={{ mr: 1, fontSize: 18 }} /> : <ForwardToInboxIcon sx={{ mr: 1, fontSize: 18 }} />}
                                        {this.state.isAH_InviteSent ? 'AH Invite Sent' : 'Invite to Ability Hub'}
                                    </MenuItem>
                                )}
                                {this.props.user.subs.find((s) => s.feature_id === 22) && this.state.ahRelationship && (
                                    <MenuItem onClick={this.startVideoCall} disabled={this.state.videoCall.starting}>
                                        <VideocamIcon sx={{ mr: 1, fontSize: 18 }} />
                                        {this.state.videoCall.starting ? 'Starting Video Call…' : 'Start Video Call'}
                                    </MenuItem>
                                )}
                                <MenuItem onClick={() => { this.setState({ referralDialogOpen: true, quickActionAnchor: null }); }}>
                                    <SendIcon sx={{ mr: 1, fontSize: 18 }} /> Create Referral
                                </MenuItem>
                            </Menu>
                        </div>
                    </div>
                    </Grid>

                        {/* Recent Notes (Activity Pulse) */}
                        <Grid size={{ xs: 12, md: 8.5 }} sx={{ height: 'calc(100vh - 320px)', display: 'flex', flexDirection: 'column' }}>
                        <div className="activity-pulse-panel">
                            <div className="panel-section-header">
                                ACTIVITY PULSE
                            </div>

                            <Box className='notes-content' sx={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', p: '6px 10px', position: 'relative' }}>
                                {!!this.state.loading &&
                                    <Box sx={{ position: 'absolute', inset: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <CircularProgress />
                                    </Box>
                                }
                                {!this.state.loading && this.state.displayItems.length === 0 &&
                                    <div style={{ margin: 30 }} className='d-flex flex-column justify-content-center align-items-center'>
                                        <MessagePage title="No Recent Activity Found" icon="far fa-sticky-note" />
                                    </div>
                                }
                                {!this.state.loading && this.state.displayItems.map((item, idx) => {
                                    const dateObj = moment(item.date);
                                    const isAudio = item.type === 'audio';
                                    return (
                                        <div key={idx} className="tl-item">
                                            <div className="tl-date-col">
                                                <span className="tl-date">{dateObj.format('MMM D')}</span>
                                                <span className="tl-time">{dateObj.format('h:mm A')}</span>
                                            </div>
                                            <div className="tl-card-col">
                                                <Card sx={{ marginBottom: '8px', width: '100%', maxWidth: 'none' }}>
                                                    <CardActions sx={{ paddingLeft: '16px', paddingRight: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <div style={{ flex: 1, minWidth: 0 }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 0 }}>
                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                    <div style={{ minWidth: 0 }}>
                                                                        {item.title
                                                                            ? <h6 style={{ marginBottom: '0px', marginRight: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.title}</h6>
                                                                            : <h6 style={{ marginBottom: '0px', marginRight: 10, color: '#aaa' }}>{isAudio ? 'Voice Note' : item.type === 'task' ? (item.subTitle || 'Task') : 'Note'}</h6>
                                                                        }
                                                                        {item.contextLabel && <p style={{ marginBottom: '0px', color: 'gray', fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.contextLabel}</p>}
                                                                        {item.subTitle && <span style={{ display: 'block', color: 'gray', fontSize: 13, marginBottom: 0, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.subTitle}</span>}
                                                                    </div>
                                                                </div>
                                                                {(item.createdBy || item.editNote) && (
                                                                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}>
                                                                        <div style={{ fontSize: 13, color: 'gray', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: 8 }}>
                                                                            {item.createdBy && (
                                                                                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                    {item.type === 'task' ? 'Completed by' : 'Created by'} {item.createdBy}{item.empType ? ` (${item.empType})` : ''}
                                                                                </span>
                                                                            )}
                                                                            {item.updatedBy && item.updatedAt && (
                                                                                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                                    {moment(item.updatedAt).format('MM/DD/YYYY hh:mm A')} updated by {item.updatedBy}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        {item.editNote && (
                                                                            <IconButton style={{ marginLeft: 0 }} onClick={() => this.setState({ editNote: item.editNote })}>
                                                                                <Icon style={{ fontSize: '16px' }} baseClassName="fas" className="fa-edit" />
                                                                            </IconButton>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </CardActions>
                                                    <CardContent sx={{ paddingBottom: '8px', paddingTop: '0px' }}>
                                                        <hr style={{ marginBottom: '10px', marginTop: '0px', backgroundColor: '#e2ecfa' }} />
                                                        {isAudio && item.audioSrc && <audio controls src={item.audioSrc} />}
                                                        {item.type === 'note' && item.content && (
                                                                <ThemeProvider theme={myTheme}>
                                                                    <MUIRichTextEditor
                                                                        defaultValue={this.isJSON(item.content) ? item.content : `{"blocks":[{"key":"block1","text":"${(item.content || '').replace(/\\/g, '\\\\').replace(/\n/g, ' ').replace(/\t/g, ' ').replace(/"/g, '\\"')}","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`}
                                                                        readOnly={true}
                                                                        toolbar={false}
                                                                    />
                                                                </ThemeProvider>
                                                            )}
                                                        {item.type === 'task' && (
                                                            <div style={{ fontSize: '0.87rem', color: '#444', paddingBottom: '4px' }}>
                                                                {item.content ? <div>{item.content}</div> : <div style={{ color: '#aaa' }}>No description</div>}
                                                            </div>
                                                        )}
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        </div>
                                    );
                                })}
                            </Box>

                            {/* Quick Note Bar */}
                            <div className="quick-note-bar">
                                <TextField
                                    placeholder="Add a quick note..."
                                    value={this.state.quickNoteText}
                                    onChange={(e) => this.setState({ quickNoteText: e.target.value })}
                                    size="small"
                                    fullWidth
                                    multiline
                                    maxRows={3}
                                    onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); this.handleQuickNoteSave(); } }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton size="small" onClick={this.handleQuickNoteSave} disabled={!this.state.quickNoteText.trim() || this.state.savingQuickNote} color="primary">
                                                    {this.state.savingQuickNote ? <CircularProgress size={16} /> : <SendIcon fontSize="small" />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    sx={{ backgroundColor: '#fff' }}
                                />
                            </div>


                        </div>
                        </Grid>

                        {/* Right Panel */}
                        <Grid size={{ xs: 12, md: 3.5 }}>
                        <Stack spacing={1.25} sx={{ height: 'calc(100vh - 320px)', overflow: 'hidden' }}>

                            {/* Contact & Locations */}
                            <div className="right-card" style={{ flex: '0 0 auto', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                                <div className="panel-section-header">CONTACT &amp; LOCATIONS</div>
                                <Box sx={{ p: '8px 10px', display: 'flex', flexWrap: 'wrap', gap: 0.75, flex: 1, minHeight: 0, overflowY: 'auto' }}>
                                    {phoneNumbers.filter(n => n.trim()).map((number, i) => (
                                        <Button key={`ph-${i}`} variant="outlined" component="a" href={`tel:${number.trim()}`}
                                            startIcon={<PhoneIcon sx={{ fontSize: 16 }} />}
                                            sx={{ flex: '1 1 45%', justifyContent: 'flex-start', textTransform: 'none', fontSize: '0.875rem', py: 0.75, px: 1, borderColor: '#c5d8f0', color: '#1565c0', fontWeight: 500, minWidth: 0 }}>
                                            {i === 0 ? 'Call Main' : 'Call Alt'}
                                        </Button>
                                    ))}
                                    {addresses.filter(a => a.trim()).map((address, i) => (
                                        <Button key={`addr-${i}`} variant="outlined" component="a"
                                            href={`https://maps.google.com/?q=${encodeURIComponent(address.trim())}`}
                                            target="_blank" rel="noopener noreferrer"
                                            startIcon={<NavigationIcon sx={{ fontSize: 16 }} />}
                                            sx={{ flex: '1 1 45%', justifyContent: 'flex-start', textTransform: 'none', fontSize: '0.875rem', py: 0.75, px: 1, borderColor: '#c5d8f0', color: '#1565c0', fontWeight: 500, minWidth: 0 }}>
                                            {i === 0 ? 'Home Address' : 'Alt Address'}
                                        </Button>
                                    ))}
                                </Box>
                            </div>

                            {/* Client Details — full schema-driven field list */}
                            <div className="right-card" style={{ flex: '3 3 0', minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                                <div className="panel-section-header">
                                    CLIENT DETAILS
                                </div>
                                <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
                                    {isFieldVisible('cus_id') && <div className="detail-row"><span className="detail-label">{getFieldLabel('cus_id', 'CUSTOMER ID')}</span><span>{this.props.cust_details.cus_id}</span></div>}
                                    {isFieldVisible('DDDID') && <div className="detail-row"><span className="detail-label">{getFieldLabel('DDDID', 'DDDID')}</span><span>{this.props.cust_details.DDDID}</span></div>}
                                    {isFieldVisible('cus_local_id') && <div className="detail-row"><span className="detail-label">{getFieldLabel('cus_local_id', 'LOCAL ID')}</span><span>{this.props.cust_details.cus_local_id}</span></div>}
                                    {isFieldVisible('cus_type') && <div className="detail-row"><span className="detail-label">{getFieldLabel('cus_type', 'TYPE')}</span><span>{this.props.cust_details.cus_type}</span></div>}
                                    {isFieldVisible('cus_status') && <div className="detail-row"><span className="detail-label">{getFieldLabel('cus_status', 'STATUS')}</span><span>{this.props.cust_details.cus_status}</span></div>}
                                    {isFieldVisible('cus_email') && <div className="detail-row"><span className="detail-label">{getFieldLabel('cus_email', 'EMAIL')}</span><span>{this.props.cust_details.cus_email}</span></div>}
                                    {isFieldVisible('cus_phone') && <div className="detail-row"><span className="detail-label">{getFieldLabel('cus_phone', 'PHONE')}</span><span>{phoneNumbers[0]}</span></div>}
                                    {isFieldVisible('cus_address') && <div className="detail-row"><span className="detail-label">{getFieldLabel('cus_address', 'ADDRESS')}</span><span>{addresses[0]}</span></div>}
                                    {isFieldVisible('dob') && <div className="detail-row"><span className="detail-label">{getFieldLabel('dob', 'DATE OF BIRTH')}</span><span>{moment(this.props.cust_details.dob?.replace(/Z/g, "")).format('MMMM DD, YYYY')}</span></div>}
                                    {isFieldVisible('PrimaryDiagnosisCode') && <div className="detail-row"><span className="detail-label">{getFieldLabel('PrimaryDiagnosisCode', 'DIAGNOSIS CODE')}</span><span>{this.props.cust_details.PrimaryDiagnosisCode}</span></div>}
                                    {isFieldVisible('SecondaryDiagnosisCode') && <div className="detail-row"><span className="detail-label">{getFieldLabel('SecondaryDiagnosisCode', 'SECONDARY DIAGNOSIS CODE')}</span><span>{this.props.cust_details.SecondaryDiagnosisCode}</span></div>}
                                    {isFieldVisible('diagnose_code') && <div className="detail-row"><span className="detail-label">{getFieldLabel('diagnose_code', 'ICD-10 DIAGNOSIS')}</span><span>{this.props.cust_details.diagnose_code}</span></div>}
                                    {isFieldVisible('gender') && <div className="detail-row"><span className="detail-label">{getFieldLabel('gender', 'GENDER')}</span><span>{this.props.cust_details.gender}</span></div>}
                                    {isFieldVisible('medicaid_eligible') && <div className="detail-row"><span className="detail-label">{getFieldLabel('medicaid_eligible', 'MEDICAID ELIGIBILITY')}</span><span>{this.props.cust_details.medicaid_eligible}</span></div>}
                                    {isFieldVisible('last_plan_approval_date') && <div className="detail-row"><span className="detail-label">{getFieldLabel('last_plan_approval_date', 'PLAN APPROVAL DATE')}</span><span>{this.props.project_details == null || !this.props.cust_details.last_plan_approval_date ? '' : moment(this.props.cust_details.last_plan_approval_date).format('MM/DD/YYYY')}</span></div>}
                                    {isFieldVisible('sign_page_date') && <div className="detail-row"><span className="detail-label">{getFieldLabel('sign_page_date', 'PLAN END DATE')}</span><span>{this.props.project_details == null || !this.props.cust_details.sign_page_date ? '' : moment(this.props.cust_details.sign_page_date).format('MM/DD/YYYY')}</span></div>}
                                    {isFieldVisible('cus_acquired_date') && <div className="detail-row"><span className="detail-label">{getFieldLabel('cus_acquired_date', 'ACQUIRED DATE')}</span><span>{moment(this.props.cust_details.cus_acquired_date).format('MM/DD/YYYY')}</span></div>}
                                    {isFieldVisible('TransferOutReason') && <div className="detail-row"><span className="detail-label">{getFieldLabel('TransferOutReason', 'TRANSFER OUT REASON')}</span><span>{this.props.cust_details.TransferOutReason ?? ''}</span></div>}
                                    {isFieldVisible('TransferOutDate') && <div className="detail-row"><span className="detail-label">{getFieldLabel('TransferOutDate', 'TRANSFER OUT DATE')}</span><span>{this.props.cust_details.TransferOutDate ? moment(this.props.cust_details.TransferOutDate).utc().format('MM/DD/YYYY') : ''}</span></div>}
                                    {isFieldVisible('place01char') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place01char', 'TEXT FIELD')}</span><span>{this.props.cust_details.place01char ?? ''}</span></div>}
                                    {isFieldVisible('place02char') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place02char', 'TEXT FIELD')}</span><span>{this.props.cust_details.place02char ?? ''}</span></div>}
                                    {isFieldVisible('place03char') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place03char', 'TEXT FIELD')}</span><span>{this.props.cust_details.place03char ?? ''}</span></div>}
                                    {isFieldVisible('place04char') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place04char', 'TEXT FIELD')}</span><span>{this.props.cust_details.place04char ?? ''}</span></div>}
                                    {isFieldVisible('place05char') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place05char', 'TEXT FIELD')}</span><span>{this.props.cust_details.place05char ?? ''}</span></div>}
                                    {isFieldVisible('place06char') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place06char', 'TEXT FIELD')}</span><span>{this.props.cust_details.place06char ?? ''}</span></div>}
                                    {isFieldVisible('place07char') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place07char', 'TEXT FIELD')}</span><span>{this.props.cust_details.place07char ?? ''}</span></div>}
                                    {isFieldVisible('place08char') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place08char', 'TEXT FIELD')}</span><span>{this.props.cust_details.place08char ?? ''}</span></div>}
                                    {isFieldVisible('place09date') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place09date', 'DATE FIELD')}</span><span>{this.props.cust_details.place09date ? moment(this.props.cust_details.place09date.replace(/Z/g, "")).format('MM/DD/YYYY') : ''}</span></div>}
                                    {isFieldVisible('place10date') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place10date', 'DATE FIELD')}</span><span>{this.props.cust_details.place10date ? moment(this.props.cust_details.place10date.replace(/Z/g, "")).format('MM/DD/YYYY') : ''}</span></div>}
                                    {isFieldVisible('place11date') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place11date', 'DATE FIELD')}</span><span>{this.props.cust_details.place11date ? moment(this.props.cust_details.place11date.replace(/Z/g, "")).format('MM/DD/YYYY') : ''}</span></div>}
                                    {isFieldVisible('place12date') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place12date', 'DATE FIELD')}</span><span>{this.props.cust_details.place12date ? moment(this.props.cust_details.place12date.replace(/Z/g, "")).format('MM/DD/YYYY') : ''}</span></div>}
                                    {isFieldVisible('place13number') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place13number', 'NUMBER FIELD')}</span><span>{this.props.cust_details.place13number ?? ''}</span></div>}
                                    {isFieldVisible('place14number') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place14number', 'NUMBER FIELD')}</span><span>{this.props.cust_details.place14number ?? ''}</span></div>}
                                    {isFieldVisible('place15number') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place15number', 'NUMBER FIELD')}</span><span>{this.props.cust_details.place15number ?? ''}</span></div>}
                                    {isFieldVisible('place16number') && <div className="detail-row"><span className="detail-label">{getFieldLabel('place16number', 'NUMBER FIELD')}</span><span>{this.props.cust_details.place16number ?? ''}</span></div>}
                                    {isFieldVisible('HasPet') && <div className="detail-row"><span className="detail-label">{getFieldLabel('HasPet', 'HAS PET')}</span><span>{this.props.cust_details.HasPet === 1 ? 'Yes' : this.props.cust_details.HasPet === 0 ? 'No' : ''}</span></div>}
                                    {isFieldVisible('ProviderGenderPreference') && <div className="detail-row"><span className="detail-label">{getFieldLabel('ProviderGenderPreference', 'PROVIDER GENDER PREFERENCE')}</span><span>{this.props.cust_details.ProviderGenderPreference ?? ''}</span></div>}
                                    {isFieldVisible('LanguagePreference') && <div className="detail-row"><span className="detail-label">{getFieldLabel('LanguagePreference', 'LANGUAGE PREFERENCE')}</span><span>{this.props.cust_details.LanguagePreference ?? ''}</span></div>}
                                    {isFieldVisible('PreferRepeatProviders') && <div className="detail-row"><span className="detail-label">{getFieldLabel('PreferRepeatProviders', 'PREFER REPEAT PROVIDERS')}</span><span>{this.props.cust_details.PreferRepeatProviders === 1 ? 'Yes' : this.props.cust_details.PreferRepeatProviders === 0 ? 'No' : ''}</span></div>}
                                    {isFieldVisible('DriverLicenseNumber') && <div className="detail-row"><span className="detail-label">{getFieldLabel('DriverLicenseNumber', 'DRIVER LICENSE NUMBER')}</span><span>{this.props.cust_details.DriverLicenseNumber ?? ''}</span></div>}
                                    {isFieldVisible('DLExpiryDate') && <div className="detail-row"><span className="detail-label">{getFieldLabel('DLExpiryDate', 'DL EXPIRY DATE')}</span><span>{this.props.cust_details.DLExpiryDate ? moment(this.props.cust_details.DLExpiryDate.replace(/Z/g, "")).format('MM/DD/YYYY') : ''}</span></div>}
                                    {isFieldVisible('DLIssueDate') && <div className="detail-row"><span className="detail-label">{getFieldLabel('DLIssueDate', 'DL ISSUE DATE')}</span><span>{this.props.cust_details.DLIssueDate ? moment(this.props.cust_details.DLIssueDate.replace(/Z/g, "")).format('MM/DD/YYYY') : ''}</span></div>}
                                    {isFieldVisible('DLIssueState') && <div className="detail-row"><span className="detail-label">{getFieldLabel('DLIssueState', 'DL ISSUE STATE')}</span><span>{this.props.cust_details.DLIssueState ?? ''}</span></div>}
                                </Box>
                            </div>

                            {/* Goal Status Widget */}
                            {this.state.customerGoals && this.state.customerGoals.length > 0 && (
                                <div className="right-card" style={{ flex: '2 2 0', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                    <div className="panel-section-header">GOAL STATUS</div>
                                    <div style={{ padding: '8px 10px', display: 'flex', flexDirection: 'column', gap: 8, overflowY: 'auto', flex: '1 1 0' }}>
                                        {this.state.customerGoals.map(goal => {
                                            const progress = Math.min(Math.max(goal.goal_progress ?? 0, 0), 100);
                                            return (
                                                <div key={goal.customer_goal_id}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.88rem', marginBottom: 5 }}>
                                                        <span style={{ fontWeight: 600, color: '#444', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '75%' }}>{goal.goal_title}</span>
                                                        <span style={{ color: '#888', flexShrink: 0 }}>{progress}%</span>
                                                    </div>
                                                    <div style={{ background: '#eceff1', borderRadius: 6, height: 12, overflow: 'hidden' }}>
                                                        <div style={{ width: `${progress}%`, height: '100%', background: 'linear-gradient(90deg,#00c853,#69f0ae)', borderRadius: 6, transition: 'width 0.6s ease' }} />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                        </Stack>
                        </Grid>
                    </Grid>
                </div>
            )
        }
        return (
            <div style={{ height: '100%' }}>
                {content}
            </div>
        )
    }
}

export default Overview;
